import React from "react";
import Logo from "../static/Logo";
import logo from "../static/logo.svg";
import doubleArrow from "/icons/double-arrow.svg";

interface CredentialBannerProps {
  /**
   * URL for the first company logo
   * @default null (will use Logo component)
   */
  firstLogoUrl?: string | null;
  /**
   * URL for the second company logo
   * @default null (will use Pluto logo)
   */
  secondLogoUrl?: string | null;
  /**
   * Alt text for the first logo
   * @default "First Company"
   */
  firstLogoAlt?: string;
  /**
   * Alt text for the second logo
   * @default "Second Company"
   */
  secondLogoAlt?: string;
  /**
   * Optional className for additional styling
   */
  className?: string;
}

export function CredentialBanner({
  firstLogoUrl = null,
  secondLogoUrl = null,
  firstLogoAlt = "First Company",
  secondLogoAlt = "Second Company",
  className,
}: CredentialBannerProps) {
  return (
    <div
      className={`w-full rounded-lg py-10 bg-background-container ${className}`}
    >
      <div className="flex items-center justify-center space-x-6">
        <div className="flex-shrink-0">
          {firstLogoUrl ? (
            <img
              src={firstLogoUrl}
              alt={firstLogoAlt}
              className="h-12 w-12 object-contain"
            />
          ) : (
            <Logo size="w-8 h-8" />
          )}
        </div>
        <div className="flex items-center justify-center">
          <img src={doubleArrow} alt="Data sharing" className="w-4 h-4" />
        </div>
        <div className="flex-shrink-0">
          {secondLogoUrl ? (
            <img
              src={secondLogoUrl}
              alt={secondLogoAlt}
              className="h-8 w-8 object-contain rounded-md"
            />
          ) : (
            <img
              src={logo}
              alt="Pluto Logo"
              className="h-7 w-7 object-contain"
            />
          )}
        </div>
      </div>
    </div>
  );
}
